import React from 'react'
import SourceChip from './SourceChip'
import RelatedCatalogEntries from '../catalog/RelatedCatalogEntries'

export default function ChatMessage({ message }) {
  if (message.role === 'user') {
    return (
      <div className="flex justify-end">
        <div className="max-w-[80%] rounded-2xl bg-accent-600 text-white px-4 py-3 text-sm leading-relaxed shadow-sm">
          {message.text}
        </div>
      </div>
    )
  }

  // assistant
  return (
    <div className="flex">
      <div className="max-w-[85%] w-full rounded-2xl bg-white border border-slate-200 px-5 py-4 shadow-sm space-y-3">
        {message.pending && !message.text && (
          <div className="flex items-center gap-2 text-sm text-slate-500">
            <span className="inline-block h-2 w-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span>Thinking…</span>
          </div>
        )}

        {message.text && (
          <div className="text-sm leading-relaxed text-slate-800 whitespace-pre-wrap">
            {message.text}
            {message.pending && (
              <span className="inline-block w-1.5 h-4 bg-accent-400 ml-0.5 align-middle animate-pulse" />
            )}
          </div>
        )}

        {message.error && (
          <div className="text-sm text-rose-600">{message.error}</div>
        )}

        {message.sources && message.sources.length > 0 && (
          <div className="pt-3 border-t border-slate-100">
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
              Sources
            </div>
            <div className="flex flex-wrap gap-2">
              {message.sources.map((source, idx) => (
                <SourceChip key={source.chunk_id || idx} source={source} index={idx} />
              ))}
            </div>
          </div>
        )}

        <RelatedCatalogEntries entries={message.relatedCatalogEntries} />
      </div>
    </div>
  )
}
